import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class MonitorAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'monitor';
	getListResultAsync(id) {
		let request = {
			url: [this.getAPIUrl(), 'result', id].join('/')
		};
		return httpClient.getAsync(request);
	}
	reCheckMonitorAsync(id) {
		let request = {
			url: [this.getAPIUrl(), 'recheck', id].join('/')
		};
		return httpClient.getAsync(request);
	}	
}

export default new MonitorAPI();